<script setup lang="ts">
import { componentMap, type InteractiveComponentKey } from '@/components/calendar/components'

import Summary from '@/components/calendar/Summary.vue';
import Monthly from '@/components/calendar/Monthly.vue';
import CalendarLayout from '@/layouts/CalendarLayout.vue';

import { ref } from 'vue'

const project = ref(0)
const projects = ref([1,2,3,4])

const selectedItem = ref<number | null>(null)
const selectedComponent = ref<InteractiveComponentKey>('summary')

function selectComponent(name: InteractiveComponentKey, pk?: number) {
  selectedComponent.value = name
  selectedItem.value = pk || null
}

</script>

<template>
  <CalendarLayout>

    <template #monthly>
      <Monthly 
        :project="project"
        :projects="projects"
      />
    </template>

    <template #interactives>
      <component
        :is="componentMap[selectedComponent]"
        :project="project"
        :key="selectedComponent" 
        :item="selectedItem"
        @navigate="selectComponent"
      />
    </template>

  </CalendarLayout>
</template>
